"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 5.75A6.25 6.25 0 0 0 5.75 12a.75.75 0 0 1-1.5 0 7.75 7.75 0 1 1 4.11 6.844.75.75 0 0 1 .706-1.324A6.25 6.25 0 1 0 12 5.75"
}), 'OriflameSpinner');
